import { computed } from "vue";
import { useStore } from "vuex";

/**
 * Returns a computed boolean for a single feature flag by name.
 * Falls back to false if the flag is not found or not yet loaded.
 *
 * Usage:
 *   const canViewCameraMode = useFeatureFlag('viewer_camera_mode')
 *   // then use canViewCameraMode.value in template or JS
 */
export function useFeatureFlag(flagName) {
  const store = useStore();
  return computed(() => store.getters.featureFlag(flagName));
}

/**
 * Returns a getter function for feature flags — useful when you need
 * to check multiple flags or reference them in Options API components.
 *
 * Usage (Composition API):
 *   const { featureFlag } = useFeatureFlags()
 *   featureFlag('viewer_camera_mode') // boolean
 *
 * Usage (Options API computed):
 *   featureFlag(name) { return this.$store.getters.featureFlag(name) }
 */
export function useFeatureFlags() {
  const store = useStore();
  const featureFlag = (name) => store.getters.featureFlag(name);
  return { featureFlag };
}
